
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectRewardSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let ProjectSections = Parse.Object.extend('Project_Rewards');

		// Define 'Project_Rewards' scheme
		let schema = [
			'title',
			'amount',
			'image',
			'description',
			'Project',
			'inventory'
		];
		
		// Load schema into object prototype
		schema.forEach(field => {
			Object.defineProperty(ProjectSections.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return ProjectSections;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/schemas/project-reward.schema.js